import Dialysis from './Dialysis'

export default Dialysis